import React from "react";

import { ReactComponent as CloseIcon } from "../../../assets/svg/close_gray.svg";
import { ReactComponent as ModalIcon } from "../../../assets/svg/actionlist_modal_icon.svg";
import { ReactComponent as ArrowRightIcon } from "../../../assets/svg/keyboard_arrow_right.svg";
import { INewAnswer } from "../../../state";
import { Context } from "../../../studentStore";

import style from "./ActionSummaryModal.module.scss";

export type ActionSummaryModalProps = {
  onClose: () => void;
  myAnswers: INewAnswer[] | [];
};

const ActionSummaryModal: React.FC<ActionSummaryModalProps> = ({
  onClose,
  myAnswers,
}) => {
  const answerContents = (myAnswers as INewAnswer[]).flatMap(a => a.contents);
  const LEARNING_INDEX = 0;
  const ACTION_INDEX = 1;
  const { state } = React.useContext(Context);

  const work3Issue = React.useMemo(() => {
    return state.lesson?.issues?.find(issue => issue.to_gear) ?? null;
  }, [state.lesson]);

  // lesson3のまとめワークでは振り返りの回答が表示できないため回答の表示非表示の制限を入れるため必要
  const isWork3IssueWithAnswers = React.useMemo(() => {
    if (!work3Issue) {
      return false;
    }
    return (myAnswers as INewAnswer[]).some(
      answer => answer.issue_id === work3Issue.id,
    );
  }, [work3Issue, myAnswers]);

  return (
    <div className={style.actionSummaryModal}>
      <div
        className={style.actionSummaryModal__backDrop}
        onClick={() => onClose()}
      />
      <div className={style.actionSummaryModal__content}>
        <button
          className={style.closeButton}
          onClick={() => onClose()}
          aria-label="閉じる"
        >
          <CloseIcon />
        </button>
        <ModalIcon />
        <div className={style.headerContainer}>
          <p className={style.title}>
            授業で学んだことを使って、行動してみましょう。
          </p>
          <div className={style.descriptionContainer}>
            <p className={style.description}>
              振り返りWORKに入力した内容は、［行動リスト］に表示されます。
              <br />
              行動した後は、行動した内容や気づきを［行動リスト］に入力してみましょう。
            </p>
          </div>
        </div>
        {isWork3IssueWithAnswers && (
          <div className={style.answerContainer}>
            <p className={style.title}>あなたの振り返り回答</p>
            <div className={style.answerBoxContainer}>
              <div className={style.answerBox}>
                <p className={style.title}>
                  {work3Issue?.questions[LEARNING_INDEX]?.statement}
                </p>
                <p className={style.description}>
                  {answerContents[LEARNING_INDEX]?.content}
                </p>
              </div>
              <ArrowRightIcon />
              <div className={style.answerBox}>
                <p className={style.title}>
                  {work3Issue?.questions[ACTION_INDEX]?.statement}
                </p>
                <p className={style.description}>
                  {answerContents[ACTION_INDEX]?.content}
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
export default ActionSummaryModal;
